import { Link } from "react-router-dom";

interface ContentMissingProps {
  message: string;
}

export default function ContentMissing({ message }: ContentMissingProps) {
  return (
    <div className="mx-auto w-full max-w-7xl px-4 py-20 md:px-8">
      <div className="flex flex-col items-center gap-4 rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-100 text-foreground-400">
          <i className="ri-emotion-sad-line text-2xl" aria-hidden="true"></i>
        </span>
        <h1 className="text-lg font-medium text-foreground-900">
          内容不存在或已下线
        </h1>
        <p className="max-w-md text-sm text-foreground-500">{message}</p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/search"
            className="whitespace-nowrap rounded-md border border-background-200 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            前往搜索
          </Link>
        </div>
      </div>
    </div>
  );
}